jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


window.onscroll = function () { //myFunction() 
};
var header = document.getElementById("header");
if (header != null) {
    var sticky = header.offsetTop;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("fixed");

    } else {
        header.classList.remove("fixed");
    }
}


/********************** Mobile menu ********************** */
jQuery(document).on("click", ".navbar-toggler,.close-menu", function (e) {
    jQuery(jQuery(this).attr('data-target')).toggleClass("show");
});

/**********************Tab And Accordian********************** */

// Loop through each tab container to set up independent tabs
$('.tab-container').each(function () {
    const $container = $(this);
    const $tabButtons = $container.find('.tab-button');
    const $tabContentItems = $container.find('.tab-content-item');

    // Set up click event for each button within this container
    $tabButtons.on('click', function () {
        const $button = $(this);
        const target = $button.data('tab');

        // Remove active class from all buttons and add to clicked button
        $tabButtons.removeClass('active');
        $button.addClass('active');

        if (target != "all") {
            // Add fade effect to content items
            $tabContentItems.filter(':visible').fadeOut(200, function () {
                $tabContentItems.addClass('hidden');
                $tabContentItems.filter(`[data-content="${target}"]`).removeClass('hidden').fadeIn(200);
            });
        } else {
            $tabContentItems.removeClass('hidden').fadeIn(200);
        }
    });
});
$('.accordion-group').each(function () {
    const $accordionGroup = $(this);

    // Toggle functionality for each accordion item
    $accordionGroup.find('.accordion-toggle').click(function () {
        // Close other items in the current group and reset icons to "+"
        $accordionGroup.find('.accordion-content').not($(this).next()).slideUp();
        $accordionGroup.find('.accordion-item').removeClass('accordion-active');
        $accordionGroup.find('.accordion-icon').not($(this).find('.accordion-icon')).addClass('rotate-180');
        $(this).parents('.accordion-item').addClass('accordion-active');

        // Toggle current item and icon
        $(this).next().slideToggle();
        const icon = $(this).find('.accordion-icon');
        icon.toggleClass('rotate-180');
    });
});

function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


$(document).ready(function () {
    lazyloader();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
        $('.header-navigation').toggleClass('open-menu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
        $('.header-navigation').removeClass('open-menu');
    });

    function cycleBannerDetailsColor() {
        const $el = $('.banner-details');
        const video = document.querySelector('.banner-details')
            ?.closest('section')
            ?.querySelector('video');

        if (!video) return;

        const WHITE_START = 2;
        const WHITE_END = 7;

        video.addEventListener('timeupdate', function () {
            const t = video.currentTime;
            const isBlack = t < WHITE_START || t >= WHITE_END;
            $el.toggleClass('text-white', !isBlack).toggleClass('text-black', isBlack);
        });
    }
    cycleBannerDetailsColor();

    $('.banner-cta-slider').slick({
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        dots: false,
        infinite: true,
        variableWidth: true,
    });

    $('.partners-slider').slick({
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
    $('.batteries-slider').slick({
        slidesToShow: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        centerMode: true,
        centerPadding: '410px',
        dots: false,
        nextArrow: $(".next-arrows"),
        prevArrow: $(".prev-arrows"),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    });
    $('.batteries-image-slider').slick({
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        centerMode: true,
        centerPadding: '400px',
        dots: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    });


    $('.product-slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-slider-for',
        dots: false,
        focusOnSelect: true,
        variableWidth: true,
    });

    $('.product-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.product-slider-nav',
        variableWidth: true,
        focusOnSelect: false,
    });

    if (window.innerWidth < 992) {
        $('.mobile-slider').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            dots: false,
        });
    }

    $('.benefits-slider').slick({
        slidesToShow: 2,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        variableWidth: true,
        lazyLoad: 'ondemand',
    });

});